module.exports = __webpack_public_path__ + "img/uid-banner.3071baa.jpg";